






















































































import Vue from 'vue';
import {EventBus, graph} from '../main';
import * as bibistore from '../modules/bibistore';
import {addLinks} from '../modules/graphbuilder';
import _ from 'lodash';



//import * as graphbuildingmachine from '../modules/graphbuilder';

export default Vue.extend({
  name: 'graphEditor',
  props: [],
  created (){
      //this.buildGraph(this.graphspec);
      this.alldoi = bibistore.alldoi();

      EventBus.$on('storageUpdate', () => {
        console.log('event in graph ed, storage')
        this.$forceUpdate();
        this.alldoi = bibistore.alldoi();
      });
  },
  data (){ return {
      doitext: '',
      data: undefined,
      waiting:false,
      alldoi: undefined,
      nodelist: graph.state.nodelist,
      links: graph.state.links,
      selectedNodes: [],
      selectall: false,
  }; },
  computed: {
      doilist (){ return this.parse_doitext(this.doitext) },
      graphmetadata (){ return bibistore.get(this.nodelist) }
      //allmetadata (){ return bibistore.get(this.alldoi) },
  },
  watch: {
    // whenever question changes, this function will run
    selectall: function (newValue, oldValue) {
      this.selectedNodes = newValue? this.nodelist.slice(0): [];
    },
  },
  filters: {
    key (doi){
      return bibistore.get([doi])[0].key
    }
  },
  methods: {
    submit(doitext: string) {
      const doilist = this.parse_doitext(doitext);

      this.waiting = true;
      this.doitext = '';
      bibistore.query(doilist).then((data)=>{

        this.waiting = false;
        //this.data = data;
        this.alldoi = bibistore.alldoi();
      })

    },
    parse_doitext(doitext: string): string[]{
      return this.doitext.split(/[,;\s]/).filter( (x) => x )
    },
    addToGraph(doilist){ graph.addToGraph(doilist); },
    removeFromGraph(doilist){ graph.removeFromGraph(doilist); },
    isInNodelist(doi){
      const match = this.nodelist.filter( (nodedoi) => nodedoi == doi )
      return match.length > 0
    },
    searchRefsOf(doilist){
      const metadata = bibistore.get(doilist)
      var refs = metadata.map( (md) => md.referenceWithDOI )
      refs =  [].concat(...refs)

      // query missing
      bibistore.query(refs).then( (metadata) => {
        this.alldoi = bibistore.alldoi();
      })
    },
    showmetadata (doi){
      EventBus.$emit('showmetadata', doi);
    },
    hasUnknownRefs(missingreflist){
      missingreflist = bibistore.get(missingreflist)
                          .filter( (metadata) => !metadata)
      return missingreflist.length
    },
    nbrInGraph(doilist){
      return doilist.filter( (doi) => _.includes(this.nodelist, doi.toLowerCase()) )
                    .length
    }
  },
  components: {
  }
});
